<template>
  <div>
    <el-switch
      v-model="value"
      @change="setValue()"
      class="mb-2"
      active-text="Опубликованные"
      inactive-text="Архивные"
    />
  <div class="feed-list-wrap">
    <feed-status v-if="value" @currentChangeStatus="setPage"/>
    <div v-else/>
    <ul class="feed-list-view">
      <li class="feed-list-view__item" v-for="(item, idx) in views" :key="idx">
        <i :class="`material-icons md18 ${item.active ? 'color_main' : 'color_gray'}`" @click="switchView">
          {{item.icon}}
        </i>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
  // components
  import FeedStatus from './FeedStatus';

  // vuex
  import { mapGetters } from 'vuex';

  // store
  import { TOGGLE_FEED_LIST_VIEW } from '../store/actions/common'
  import { SET_PAGE, GET_FEEDS } from "../store/actions/feeds";
  import { SET_PUBLISHED } from '../store/actions/feeds';

  export default {
    name: "feedListView",
    data() {
      return {
        value: true,
      };
    },
    computed: {
      ...mapGetters([
        'listView',
      ]),
      views() {
        return {
          panel: {
            icon: 'view_quilt',
            active: !this.listView
          },
          list: {
            icon: 'list',
            active: this.listView
          },
        }
      }
    },
    methods: {
    setValue(){
      localStorage.setItem("published", this.value)
      this.$store.dispatch(SET_PUBLISHED, this.value);
      this.$emit("currentPageStatus", 1);
    },
    setPage(value) {
      this.$emit("currentPageStatus", value);
    },
      switchView() {
        this.$store.dispatch(SET_PAGE, 1);
        this.$store.dispatch(TOGGLE_FEED_LIST_VIEW);
        this.$emit("currentPageStatus", 1);
        this.$store.dispatch(GET_FEEDS, 1);
      }
    },
    components: {
      FeedStatus
    }
  };
</script>

<style>
  .feed-list-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #E4E7ED;
    margin-bottom: 15px;
    padding-bottom: 10px;
  }
  .feed-list-view {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: flex-end;
  }
  .feed-list-view__item {
    cursor: pointer;
    margin-left: 8px;
  }
</style>
